<div class="naming-container">
  <label class="label">Summary</label>
  <div class="summary" *ngFor="let summary of summaryData">
    <div class="summary-label">{{ summary.title }}:</div>
    <div class="data">
      <span *ngFor="let data of summary.data; let i = index">
        <ng-container *ngIf="i <= 10 && i + 1 !== summary.data.length"
          >{{ data }},
        </ng-container>
        <ng-container *ngIf="i <= 10 && i + 1 === summary.data.length">{{
          data
        }}</ng-container>
      </span>
      <ng-container *ngIf="summary.data.length > 11"
        >and {{ summary.data.length - 11 }} more...</ng-container
      >
    </div>
  </div>
  <div class="summary" *ngIf="type !== 'Comparison'">
    <div class="summary-label">Date Period:</div>
    <div class="data">{{ periodLabel }}</div>
  </div>

  <div class="comps-name">
    <label>Peer Analysis Table Name:</label>
    <input
      nz-input
      #name
      nzSize="small"
      placeholder="Enter Peer Analysis Table Name"
      [(ngModel)]="CompsName"
      (keyup)="onChangeCompsName()"
      maxlength="100"
      [ngClass]="[compsNameError ? 'err-border' : '']"
    />
    <span class="error-color comps-name-error" [hidden]="compsNameError === ''">
      <va-icon name="exclamation-triangle"></va-icon>
      {{ compsNameError }}</span
    >
  </div>
</div>
